module.exports = __webpack_public_path__ + "img/collection-weddingRingsMillgrif.1c8d84f.jpg";